import { render, staticRenderFns } from "./HostingAddons.vue?vue&type=template&id=0de8c562&"
import script from "./HostingAddons.vue?vue&type=script&lang=js&"
export * from "./HostingAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de8c562')) {
      api.createRecord('0de8c562', component.options)
    } else {
      api.reload('0de8c562', component.options)
    }
    module.hot.accept("./HostingAddons.vue?vue&type=template&id=0de8c562&", function () {
      api.rerender('0de8c562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/HostingAddons.vue"
export default component.exports